import { forEach } from "lodash"

class App {
  constructor() {
    this.searchMenu()
    this.personal()
    this.header()
  }

  searchMenu() {
    try {
        let searchWrap = document.querySelector('.search-wrap')
      let buttonSearch = searchWrap.querySelector('.button-search')
      let formWrap = searchWrap.querySelector('.form-wrap')
      let input = formWrap.querySelector('input')
      let iconButtonSearch = buttonSearch.querySelectorAll('svg')
       let expanded = false
      buttonSearch.addEventListener('click', () => {
        expanded = !expanded
        iconButtonSearch.forEach((item) => {
          item.classList.toggle('hidden')
        })

      if (expanded) {
        formWrap.classList.remove('scale-y-0')
        formWrap.classList.add('scale-y-[36px]')
        input.focus()
      } else {
        formWrap.classList.remove('scale-y-[36px]')
        formWrap.classList.add('scale-y-0')
      }

      })

    } catch (error) {

    }
  }

  personal() {
    try {
      let personal = document.querySelector('.personal')

      personal?.querySelectorAll('.parent').forEach(prt => {
        let child = prt.querySelector('.child')
        prt.addEventListener('click', () => {
          child.classList.toggle('hidden')
        })
      });

    } catch (error) {

    }
  }

  header() {
    try {
      let menuIcon = document.querySelector('.header-menu-icon')

      // let menuBarIcon = menuIcon.querySelector('.menu-bar')
      // let menuCloseIcon = menuIcon.querySelector('.close')
      let menuBar = document.querySelector('.menu-bar')
      let body = document.querySelector('body')
      menuIcon.onclick = (e) => {
        // menuBarIcon.classList.toggle('hidden')
        // menuCloseIcon.classList.toggle('hidden')
        menuBar.classList.toggle('hidden')
        body.classList.toggle('fixed')
        body.classList.toggle('overflow-hidden')
      }

    } catch (error) {
      // console.log('App.header', { message: error.message })
    }
  }
}

export default window.addEventListener('DOMContentLoaded', () => {
  new App()
})